import React, { useEffect, useMemo, useState } from 'react'
import classes from './profile.module.css'
import {
    ValidatedFormInput,
    ValidatedFormTextArea,
} from '../../../components/Form/Inputs/Inputs'
import { Dropzone } from '../../../components/Form/Dropzone/Dropzone'
import { ReactComponent as PencilIcon } from '../../../assets/icons/pencil.svg'
import { Button } from '../../../components/Button/Button'
import classNames from 'classnames'
import { useDispatch, useSelector } from 'react-redux'
import { userActions, userSelectors } from '../../../redux/userSlice'
import { profileActions, profileSelectors } from '../../../redux/profileSlice'
import { updateUser } from '../../../api/profileApi'
import notification from '../../../components/Notification/notification'
import { Formik } from 'formik'
import { ProfileSchema } from '../../../util/formSchemas'
import PreviewImageUploader from '../../../components/Form/PreviewImageUploader/PreviewImageUploader'
import useProfileForm from '../../../hooks/useProfileForm'
import userAvatar from '../../../assets/images/avatar-dark.svg'

const Profile = () => {
    const user = useSelector(userSelectors.userDetails)

    const [dp, setDp] = useState(null)

    const fileURL = useMemo(() => dp && URL.createObjectURL(dp), [dp])

    const setDpHelper = newDp => {
        if (dp) {
            URL.revokeObjectURL(dp)
        }

        setDp(newDp)
    }

    const updateDetails = useProfileForm()

    return (
        <Formik
            initialValues={{
                firstname: user.firstname,
                lastname: user.lastname,
                bio: user.bio,
            }}
            validationSchema={ProfileSchema}
            onSubmit={values => updateDetails(values, dp)}
        >
            {({ handleSubmit }) => (
                <>
                    <h1 className={classes.profileHeader}>Basic Information</h1>
                    <div className={classes.formRow}>
                        <ValidatedFormInput
                            label={'First Name'}
                            name={'firstname'}
                            id={'firstname'}
                        />
                        <ValidatedFormInput
                            label={'Last Name'}
                            name={'lastname'}
                            id={'lastname'}
                        />
                    </div>
                    <ValidatedFormTextArea
                        label={'Brief Bio'}
                        className={classes.textArea}
                        name={'bio'}
                        id={'bio'}
                    />
                    <div className={classes.dropzone}>
                        <span className={classes.label}>Profile Picture</span>
                        <Dropzone
                            acceptedFileTypes={['image/jpeg', 'image/png']}
                            onChooseFile={setDpHelper}
                            sizeLimit={3}
                            defaultSrc={userAvatar}
                        />
                        {dp && (
                            <img
                                src={fileURL}
                                alt="Preview Dp"
                                className={classes.imagePreview}
                            />
                        )}
                    </div>
                    <span className={classes.splitLine} />
                    <Button onClick={handleSubmit}>Save Changes</Button>
                </>
            )}
        </Formik>
    )
}

export default Profile
